:host {
  display: flex;
  width: 100%;

  /** @prop --grid-row-columns-xs: Set the number of columns in the grid at the smallest screen size. */
  --grid-row-columns-xs: 4;

  /** @prop --grid-row-columns-sm: Set the number of columns in the grid at the small screen size. */
  --grid-row-columns-sm: 8;

  /** @prop --grid-row-columns-md: Set the number of columns in the grid at the medium screen size. */
  --grid-row-columns-md: 12;

  /** @prop --grid-row-columns-lg: Set the number of columns in the grid at the large screen size. */
  --grid-row-columns-lg: 12;

  /** @prop --grid-row-columns-xl: Set the number of columns in the grid at the extra large screen size. */
  --grid-row-columns-xl: 12;

  /** @prop --grid-row-gutter-xs: Set the space between rows in the grid at the smallest screen size. */
  --grid-row-gutter-xs: var(--b-size-layout-xsmall);

  /** @prop --grid-row-gutter-sm: Set the space between rows in the grid at the small screen size. */
  --grid-row-gutter-sm: var(--b-size-layout-xsmall);

  /** @prop --grid-row-gutter-md: Set the space between rows in the grid at the medium screen size. */
  --grid-row-gutter-md: var(--b-size-layout-xsmall);

  /** @prop --grid-row-gutter-lg: Set the space between rows in the grid at the large screen size. */
  --grid-row-gutter-lg: var(--b-size-layout-xsmall);

  /** @prop --grid-row-gutter-xl: Set the space between rows in the grid at the extra large screen size. */
  --grid-row-gutter-xl: var(--b-size-layout-xsmall);

  /** @prop --grid-row-horizontal-gap-xs: Set the space between columns in the grid at the smallest screen size. */
  --grid-row-horizontal-gap-xs: var(--b-size-layout-medium);

  /** @prop --grid-row-horizontal-gap-sm: Set the space between columns in the grid at the small screen size. */
  --grid-row-horizontal-gap-sm: var(--b-size-layout-medium);

  /** @prop --grid-row-horizontal-gap-md: Set the space between columns in the grid at the medium screen size. */
  --grid-row-horizontal-gap-md: var(--b-size-layout-medium);

  /** @prop --grid-row-horizontal-gap-lg: Set the space between columns in the grid at the large screen size. */
  --grid-row-horizontal-gap-lg: var(--b-size-layout-medium);

  /** @prop --grid-row-horizontal-gap-xl: Set the space between columns in the grid at the extra large screen size. */
  --grid-row-horizontal-gap-xl: var(--b-size-layout-medium);
}

.anchor-c-grid-row {
  --grid-row-columns: var(--grid-row-columns-xs);
  --grid-row-gutter: var(--grid-row-gutter-xs);
  --grid-row-horizontal-gap: var(--grid-row-horizontal-gap-xs);
  width: 100%;
  display: grid;
  grid-template-columns: repeat(var(--grid-row-columns), minmax(0, 1fr));
  column-gap: var(--grid-row-gutter-xs);
  row-gap: var(--grid-row-horizontal-gap);
  @media (max-width: 599px) {
    --grid-row-columns: var(--grid-row-columns-xs);
    --grid-row-gutter: var(--grid-row-gutter-xs);
    --grid-row-horizontal-gap: var(--grid-row-horizontal-gap-xs);
  }
  @media (min-width: 600px) and (max-width: 904px) {
    --grid-row-columns: var(--grid-row-columns-sm);
    --grid-row-gutter: var(--grid-row-gutter-sm);
    --grid-row-horizontal-gap: var(--grid-row-horizontal-gap-sm);
  }
  @media (min-width: 905px) and (max-width: 1239px) {
    --grid-row-columns: var(--grid-row-columns-md);
    --grid-row-gutter: var(--grid-row-gutter-md);
    --grid-row-horizontal-gap: var(--grid-row-horizontal-gap-sm);
  }
  @media (min-width: 1240px) and (max-width: 1439px) {
    --grid-row-columns: var(--grid-row-columns-lg);
    --grid-row-gutter: var(--grid-row-gutter-lg);
    --grid-row-horizontal-gap: var(--grid-row-horizontal-gap-sm);
  }
  @media (min-width: 1440px) {
    --grid-row-columns: var(--grid-row-columns-xl);
    --grid-row-gutter: var(--grid-row-gutter-xl);
    --grid-row-horizontal-gap: var(--grid-row-horizontal-gap-xl);
  }
}
